import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'    
import { createPinia } from 'pinia'


import axios from 'axios'
axios.defaults.baseURL = process.env.VUE_APP_BACK_URL
axios.defaults.withCredentials = true

const app = createApp(App);

app.use(createPinia()); 
app.use(router);
app.use(vuetify);

function isTokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    return payload.exp * 1000 < Date.now()
  } catch {
    return true
  }
}


async function startApp() {
  const urlParams = new URLSearchParams(window.location.search)
  let auth_token = urlParams.get('token')

  if (auth_token) {
    localStorage.setItem('auth_token', auth_token)
  } else {
    auth_token = localStorage.getItem('auth_token')
  }

  if (!auth_token || isTokenExpired(auth_token)) {
    window.location.replace('https://burutik.eus')
    return
    }

  try {
    const res = await axios.get('/auth/check', {
      headers: { Authorization: `Bearer ${auth_token}` }
    })

    if (!res.data.ok) {
      window.location.replace('https://burutik.eus')
      return
    }

    await router.isReady()
    app.mount('#app')

  } catch (err) {
    window.location.replace('https://burutik.eus')
  }
}

startApp()